var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCripto256(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#5a9bd5;}.cls-3{fill:#ececec;}.cls-4,.cls-6,.cls-8{fill:#139dd9;}.cls-5,.cls-6,.cls-8{stroke-miterlimit:10;}.cls-5,.cls-8{stroke-width:5.33px;}.cls-5,.cls-7{fill:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_2);}.cls-5{stroke:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_1);}.cls-6{stroke-width:5px;}.cls-6,.cls-8{stroke:url(#\u041D\u043E\u0432\u044B\u0439_\u043E\u0431\u0440\u0430\u0437\u0435\u0446_\u0443\u0437\u043E\u0440\u0430_2);}"), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_2",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 2",
    width: 78,
    height: 78,
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 78 78"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 78,
    height: 78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 78,
    height: 78
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "\\u041D\\u043E\\u0432\\u044B\\u0439_\\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446_\\u0443\\u0437\\u043E\\u0440\\u0430_1",
    "data-name": "\\u041D\\u043E\\u0432\\u044B\\u0439 \\u043E\\u0431\\u0440\\u0430\\u0437\\u0435\\u0446 \\u0443\\u0437\\u043E\\u0440\\u0430 1",
    width: 78,
    height: 78,
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 78 78"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 78,
    height: 78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 78,
    height: 78
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cripto_256-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2_\\u043A\\u043E\\u043F\\u0438\\u044F_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2 \\u043A\\u043E\\u043F\\u0438\\u044F 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 256,
    height: 256
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 128,
    cy: 128.27,
    rx: 122.67,
    ry: 122.41
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 128,
    cy: 128.27,
    rx: 112,
    ry: 111.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M176,208H80a15.9,15.9,0,0,1-16-15.87V64.4C64,55.59,71.16,48,80,48h96c8.84,0,16,7.59,16,16.4V192.13A15.9,15.9,0,0,1,176,208Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M178.5,189.64a4.68,4.68,0,0,1-4.83,4.86H82.33a4.68,4.68,0,0,1-4.83-4.86V66.94c0-2.87,2.07-5.44,4.83-5.44h91.34c2.76,0,4.83,2.57,4.83,5.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 96,
    y: 75.05,
    width: 64,
    height: 10.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 96,
    y: 96.34,
    width: 64,
    height: 10.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 96,
    y: 117.63,
    width: 64,
    height: 10.64
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "146.67 231.34 128 216.94 109.33 231.34 109.33 162.86 146.67 162.86 146.67 231.34"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 128,
    cy: 162.86,
    rx: 21.33,
    ry: 21.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M128,141.57a21.29,21.29,0,1,1-21.33,21.29A21.32,21.32,0,0,1,128,141.57m0-5.32a26.62,26.62,0,1,0,26.66,26.61A26.67,26.67,0,0,0,128,136.25Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 128,
    cy: 162.86,
    rx: 9.78,
    ry: 9.76
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCripto256);
export default __webpack_public_path__ + "static/media/cripto_256.eebfdd14bc5741fe4a3f9c98c8b471a0.svg";
export { ForwardRef as ReactComponent };